<template>
    <div class="media-content" :class="layout">
        <div class="media-info">
            <div
                v-if="type === 'text' && (!!title || !!subTitle)"
                class="title-text"
            >
                <div
                    v-if="title"
                    class="media-title"
                    role="heading"
                    :aria-level="1"
                    v-html="formatFontSize(title, titleSize)"
                    :style="{titleStyle, textAlign: titleAlign}"
                ></div>
                <div
                    v-if="subTitle"
                    role="heading"
                    class="media-subtitle"
                    :aria-level="3"
                    v-html="formatFontSize(subTitle, subTitleSize)"
                    :style="{subTitleStyle, textAlign: titleAlign}"
                ></div>
                <div
                    v-show="showShadow"
                    class="media-shadow"
                    :style="shadowStyle"
                ></div>
            </div>
            <div
                v-if="type === 'image' && !!titlePic"
                class="title-image"
                :style="{ textAlign: imgAlign }"
            >
                <site-img
                    :src="titlePic.imgUrl || titlePic"
                    :alt="titlePic.alt || ''"
                    dir="height"
                ></site-img>
            </div>
            <slot name="info"></slot>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'text'
        },
        title: {
            type: String,
            default: ''
        },
        titleSize: {
            type: Number,
            default: 48
        },
        titleStyle: {
            type: Object,
            default: () => ({})
        },
        subTitle: {
            type: String,
            default: ''
        },
        subTitleSize: {
            type: Number,
            default: 24
        },
        subTitleStyle: {
            type: Object,
            default: () => ({})
        },
        titlePic: {
            validator: function(value) {
                return (
                    typeof value === 'string' ||
                    typeof value === 'object' ||
                    !value
                );
            },
            default: ''
        },
        imgAlign: {
            type: String,
            default: 'center'
        },
        titleAlign: {
            type: String,
            default: ''
        },
        layout: {
            type: String,
            default: 'column'
        },
        showShadow: {
            type: Boolean,
            default: false
        },
        shadowStyle: {
            type: Object,
            default: () => ({})
        }
    }
};
</script>

<style lang="scss">
@import '../theme/media.scss';
@import '../theme/mixin.scss';
.media-content {
    position: relative;
    max-width: 80%;
    z-index: var(--level-sublow);
    display: flex;
    flex-direction: column;
    align-items: center;
    @include media-min-1080 {
        &.row {
            flex-direction: row;
            justify-content: space-between;
            .media-info {
                flex: 1;
                + * {
                    margin-left: 10%;
                }
                .title-text {
                    text-align: left;
                }
            }
        }
    }
    @mixin media-content_column {
        flex-direction: column;
        max-width: var(--module-width, 1000px);
        .title-text {
            text-align: center;
        }
    }
    &.column {
        @include media-content_column;
    }
    @include media-1080 {
        &.row2column {
            @include media-content_column;
        }
    }
    .title-text {
        position: relative;
        padding: 21px 0;
        p {
            overflow: hidden;
            line-height: inherit;
        }
        .media-title {
            font-family: var(--mg-title-font);
            font-size: 48px;
            line-height: 1.1;
            @include color-theme();
        }
        .media-subtitle {
            font-family: var(--font-normal);
            font-size: 24px;
            @include color-theme();
        }
        .media-shadow {
            position: absolute;
            left: 50%;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: -1;
            background-color: #000000;
            opacity: 0.6;
            transform: translateX(-50%);
            white-space: nowrap;
        }
    }
    .title-image {
        text-align: center;
        margin-bottom: 40px;
        width: 100%;
        min-height: 80px;
        overflow: hidden;
        img {
            max-width: 100%;
            max-height: 100px;
            min-height: 80px;
            @include media-min-600 {
                max-height: 240px;
                min-height: 150px;
            }
        }
    }
    @include media-600 {
        max-width: 95%;
        min-width: 75%;
    }
}
</style>
